import { useUpdateEffect } from 'ahooks';
import * as React from 'react';
import { IApiaFilter } from './ApiaFilter';
import { DateInput, getFieldErrorStyles } from '../forms';

const NoMemoApiaDateFilter = (
  { filter, onChange, onBlur, onPressEnter }: IApiaFilter,
  ref: React.Ref<HTMLInputElement | HTMLSelectElement>,
) => {
  const [value, setValue] = React.useState<string>(String(filter.currentValue));
  const [lastDispatchedValue, setLastDispatchedValue] = React.useState<string>(
    String(filter.currentValue),
  );

  const handleClick = React.useCallback((ev: React.MouseEvent) => {
    ev.stopPropagation();
  }, []);

  useUpdateEffect(() => {
    setValue(filter.currentValue as string);
  }, [filter.currentValue]);

  return (
    <DateInput
      value={value}
      sx={getFieldErrorStyles(!filter.error)}
      aria-label={filter.toolTip}
      ref={ref as React.Ref<HTMLInputElement>}
      placeholder={filter.placeholder}
      onChange={(ev) => {
        if (onChange) {
          const result = onChange(String(ev));
          if (result === true) {
            setValue(ev);
            return true;
          }
          return result as string | false | void;
        }
        return false;
      }}
      onClick={handleClick}
      onBlur={() => {
        if (value !== lastDispatchedValue && onBlur) {
          setLastDispatchedValue(value);
          setValue(value);
          onBlur(value);
        }
      }}
      onKeyDown={(ev) => {
        if (ev.key.toLowerCase() === 'enter' && onPressEnter) {
          setLastDispatchedValue(value);
          onPressEnter(value);
        }
      }}
    />
  );
};

export const ApiaDateFilter = React.forwardRef(NoMemoApiaDateFilter);
